import React from 'react';
import connect from 'Shared/connect';
import classnames from 'classnames';
import * as styles from '../base.scss';
import ProductListItem from './ProductListItem';
const ProductList = (props) => (React.createElement("ul", { className: classnames(styles.product_list, props.className, props.isLargeContentCard ? styles.product_list__large : "") }, props.products.map((product, i) => (React.createElement("li", { key: i },
    React.createElement(ProductListItem, Object.assign({ product: product, index: i }, props)))))));
export default connect((state) => ({
    isLoggedIn: state.currentUser.isLoggedIn,
    isSupplierSalesman: state.currentUser.isSupplierSalesman,
}))(ProductList);
